import React from "react";
export {default as ArrowUp} from "./ArrowUp";
export {default as InfoIcon} from "./InfoIcon";
export {default as LeftArrowSvg} from "./LeftArrowSvg";
export {default as RightArrowSvg} from "./RightArrowSvg";
export {default as ServingsIcon} from "./ServingsIcon";
export {default as WarningSign} from "./WarningSign";

export function Beef() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="lucide lucide-beef"
      viewBox="0 0 24 24"
    >
      <circle cx="12.5" cy="8.5" r="2.5"></circle>
      <path d="M12.5 2a6.5 6.5 0 00-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 005 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0012.5 2z"></path>
      <path d="M18.5 6l2.19 4.5a6.48 6.48 0 01.31 2 6.49 6.49 0 01-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 01-2.68-1.66L2.4 16.5"></path>
    </svg>
  );
}
export function DrumStick() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="lucide lucide-drumstick"
      viewBox="0 0 24 24"
    >
      <path d="M15.45 15.4c-2.13.65-4.3.32-5.7-1.1-2.29-2.27-1.76-6.5 1.17-9.42 2.93-2.93 7.15-3.46 9.43-1.18 1.41 1.41 1.74 3.57 1.1 5.71-1.4-.51-3.26-.02-4.64 1.36-1.38 1.38-1.87 3.23-1.36 4.63z"></path>
      <path d="M11.25 15.6l-2.16 2.16a2.5 2.5 0 11-4.56 1.73 2.49 2.49 0 01-1.41-4.24 2.5 2.5 0 013.14-.32l2.16-2.16"></path>
    </svg>
  );
}
export function Fish() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="lucide lucide-fish"
      viewBox="0 0 24 24"
    >
      <path d="M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6zM18 12v.5M16 17.93a9.77 9.77 0 010-11.86"></path>
      <path d="M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 011.98 1.67l.23 1.4M16.01 17.93l-.23 1.4A2 2 0 0113.8 21H9.5a5.96 5.96 0 001.49-3.98"></path>
    </svg>
  );
}
export function MilkOff() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="lucide lucide-milk-off"
      viewBox="0 0 24 24"
    >
      <path d="M8 2h8M9 2v1.343M15 2v2.789a4 4 0 00.672 2.219l.656.984a4 4 0 01.672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 007 10.212V20a2 2 0 002 2h6a2 2 0 002-2v-3"></path>
      <path d="M7 15a6.47 6.47 0 015 0 6.472 6.472 0 003.435.435"></path>
      <path d="M2 2L22 22"></path>
    </svg>
  );
}
export function WheatOff() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      className="lucide lucide-wheat-off"
      viewBox="0 0 24 24"
    >
      <path d="M2 22l10-10M16 8l-1.17 1.17M3.47 12.53L5 11l1.53 1.53a3.5 3.5 0 010 4.94L5 19l-1.53-1.53a3.5 3.5 0 010-4.94zM8 8l-.53.53a3.5 3.5 0 000 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 01.28 4.62M20 2h2v2a4 4 0 01-4 4h-2V6a4 4 0 014-4z"></path>
      <path d="M11.47 17.47L13 19l-1.53 1.53a3.5 3.5 0 01-4.94 0L5 19l1.53-1.53a3.5 3.5 0 014.94 0zM16 16l-.53.53a3.5 3.5 0 01-4.94 0L9 15l1.53-1.53a3.49 3.49 0 011.97-.98M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 00-4.62-.28"></path>
      <path d="M2 2L22 22"></path>
    </svg>
  );
}
export function Clock() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}
export function Fire() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
    </svg>
  );
}
export function Smile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
      <path strokeWidth="3" d="M9 9L9.01 9"></path>
      <path strokeWidth="3" d="M15 9L15.01 9"></path>
    </svg>
  );
}
export function Close(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </svg>
  );
}
export function Star() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path d="M12 2L15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2z"></path>
    </svg>
  );
}
export function Step1(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="163"
      height="170"
      fill="none"
      viewBox="0 0 163 170"
      {...props}
    >
      <path
        fill="#F4E0D8"
        d="M163 82.96c0 42.462-33.656 87.04-74.406 87.04C47.844 170 0 125.422 0 82.96 0 40.347 47.843 0 88.594 0 129.344 0 163 40.347 163 82.96z"
      ></path>
      <g fill="#9E6852" clipPath="url(#clip0)">
        <path d="M71.236 37c-3.674 0-7.143 2.6-9.768 7.32-2.36 4.244-3.714 9.657-3.714 14.85 0 5.312 2.767 10.148 7.22 12.62 1.532.85 2.434 2.433 2.355 4.129l-.37 7.973a1.41 1.41 0 102.817.131l.37-7.973c.13-2.774-1.328-5.351-3.803-6.725-3.558-1.975-5.768-5.867-5.768-10.155 0-4.728 1.224-9.641 3.358-13.479 2.075-3.73 4.736-5.87 7.303-5.87s5.23 2.14 7.304 5.87c2.134 3.838 3.358 8.75 3.358 13.479 0 4.288-2.21 8.18-5.768 10.155-2.475 1.374-3.933 3.95-3.804 6.725l2.348 50.529a3.411 3.411 0 01-.948 2.536 3.41 3.41 0 01-2.49 1.065 3.41 3.41 0 01-2.49-1.065 3.412 3.412 0 01-.948-2.536l1.716-36.92a1.41 1.41 0 00-1.343-1.475 1.416 1.416 0 00-1.474 1.343l-1.716 36.921a6.205 6.205 0 001.726 4.614 6.206 6.206 0 004.53 1.938 6.206 6.206 0 004.529-1.938 6.205 6.205 0 001.725-4.614l-2.348-50.53c-.079-1.695.824-3.277 2.356-4.127 4.453-2.472 7.22-7.309 7.22-12.621 0-5.193-1.354-10.606-3.714-14.85C78.38 39.6 74.91 37 71.236 37zM109.543 71.85c4.318-2.362 6.942-7.06 6.685-11.969l-1.013-19.384A3.69 3.69 0 00111.53 37a3.664 3.664 0 00-2.639 1.11 3.66 3.66 0 00-1.05 2.664l.38 16.776a.706.706 0 01-.705.72.706.706 0 01-.704-.697l-.174-17.256A3.363 3.363 0 00103.287 37a3.362 3.362 0 00-3.352 3.318l-.174 17.255a.707.707 0 01-1.208.486.7.7 0 01-.2-.508l.382-16.873a3.569 3.569 0 00-1.024-2.596A3.57 3.57 0 0095.139 37a3.596 3.596 0 00-3.592 3.409L90.529 59.88c-.26 4.98 2.3 9.57 6.683 11.975 1.45.795 2.337 2.41 2.257 4.115l-1.389 29.893a1.41 1.41 0 102.817.131l1.39-29.893c.128-2.771-1.331-5.409-3.718-6.72-3.425-1.879-5.427-5.463-5.224-9.354l1.018-19.472a.776.776 0 011.552.058l-.382 16.872a3.497 3.497 0 001.003 2.544 3.497 3.497 0 002.52 1.061 3.536 3.536 0 003.525-3.49l.174-17.255a.533.533 0 011.063 0l.174 17.256a3.536 3.536 0 003.524 3.49c.957 0 1.852-.378 2.52-1.062a3.496 3.496 0 001.004-2.543l-.38-16.777a.865.865 0 01.248-.628.869.869 0 011.49.563l1.014 19.384c.204 3.892-1.797 7.473-5.222 9.345-2.389 1.306-3.849 3.94-3.72 6.712l2.347 50.492c.044.961-.3 1.87-.971 2.559a3.376 3.376 0 01-2.534 1.042 3.357 3.357 0 01-2.399-1.079 3.615 3.615 0 01-.968-2.626l.689-14.827a1.41 1.41 0 00-2.817-.131l-.689 14.827a6.451 6.451 0 001.727 4.685 6.151 6.151 0 004.52 1.972 6.29 6.29 0 004.493-1.896 6.288 6.288 0 001.766-4.657l-2.347-50.492c-.079-1.702.806-3.314 2.256-4.106z"></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path
            fill="#fff"
            d="M0 0H96V96H0z"
            transform="translate(39 37)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}
export function Step2(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="163"
      height="170"
      fill="none"
      viewBox="0 0 163 170"
      {...props}
    >
      <path
        fill="#DDF4D5"
        d="M163 82.96c0 42.462-33.656 87.04-74.406 87.04C47.844 170 0 125.422 0 82.96 0 40.347 47.843 0 88.594 0 129.344 0 163 40.347 163 82.96z"
      ></path>
      <g fill="#7BA26E" clipPath="url(#clip0)">
        <path d="M57.756 105.688c-.857-.681-2.134-.574-2.852.238l-5.062 5.726-1.829-1.468c-.853-.685-2.13-.585-2.853.223-.723.808-.617 2.019.236 2.703l3.383 2.715a2.09 2.09 0 001.48.448 2.065 2.065 0 001.38-.679l6.37-7.205c.716-.812.603-2.021-.253-2.701z"></path>
        <path d="M134.258 74.546h-2.893c-2.422-.112-4.371-2.178-6.625-4.568-1.506-1.597-3.119-3.307-5.062-4.574V48.18a5.504 5.504 0 00-5.495-5.501H48.54a5.505 5.505 0 00-5.495 5.501v13.976a2.014 2.014 0 104.025 0V48.18c0-.797.673-1.472 1.47-1.472h22.27v17.825a2.016 2.016 0 002.013 2.015c.37 0 .74-.102 1.067-.306l7.474-4.677 7.47 4.677a2.011 2.011 0 003.079-1.708V46.709h22.27c.797 0 1.47.674 1.47 1.472v15.515a10.984 10.984 0 00-2.068-.233h-11.406c-2.426.038-3.673 1.139-4.291 2.056-.96 1.423-1.05 3.35-.252 5.425.186.484.413.942.673 1.373H83.05c-3.279 0-5.947 2.67-5.947 5.952 0 .675.113 1.324.32 1.93h-.534c-3.279 0-5.946 2.67-5.946 5.953 0 3.282 2.667 5.953 5.946 5.953h.533a5.938 5.938 0 00-.319 1.923c0 3.18 2.498 5.786 5.631 5.95a5.929 5.929 0 00-.321 1.932c0 3.283 2.668 5.953 5.946 5.953h24.934a9.68 9.68 0 002.361-.285v6.313c0 .801-.674 1.477-1.471 1.477H67.567c.395-1.407.61-2.889.61-4.421 0-9.025-7.334-16.367-16.349-16.367-1.654 0-3.252.25-4.759.71V80.27a2.014 2.014 0 10-4.024 0v16.883c-4.544 2.911-7.565 8.004-7.565 13.794 0 9.028 7.334 16.373 16.35 16.373 5.928 0 11.13-3.178 13.997-7.922h48.356c3.03 0 5.495-2.471 5.495-5.507v-8.295c.445-.318.87-.644 1.282-.962 1.777-1.371 3.312-2.555 5.755-2.555h7.543a4.267 4.267 0 004.262-4.261V78.813a4.27 4.27 0 00-4.262-4.267zm-46.37-13.648l-5.456-3.416a2.011 2.011 0 00-2.134 0l-5.463 3.417V46.71h13.053V60.9zm-36.059 62.393c-6.796 0-12.324-5.538-12.324-12.344 0-6.803 5.528-12.338 12.324-12.338s12.324 5.535 12.324 12.338c0 6.806-5.528 12.344-12.324 12.344zm82.666-25.473a.24.24 0 01-.237.232h-7.543c-3.815 0-6.151 1.802-8.213 3.392-1.732 1.337-3.1 2.392-5.21 2.392H88.359a1.925 1.925 0 010-3.847h6.68a2.014 2.014 0 002.013-2.015 2.014 2.014 0 00-2.013-2.014h-11.99a1.927 1.927 0 010-3.853h11.99a2.014 2.014 0 002.013-2.015 2.013 2.013 0 00-2.013-2.015h-18.15a1.925 1.925 0 010-3.847h18.15a2.014 2.014 0 002.013-2.014 2.013 2.013 0 00-2.013-2.015h-11.99a1.927 1.927 0 010-3.853h29.741a2.014 2.014 0 000-4.03h-7.285a4.37 4.37 0 01-4.112-2.818c-.382-.996-.278-1.563-.169-1.724.109-.162.502-.272 1.003-.282h11.304c3.393.068 5.769 2.587 8.283 5.252 2.63 2.79 5.35 5.673 9.432 5.83l.077.001h2.935a.24.24 0 01.237.238v19.005z"></path>
        <path d="M45.14 73.04c1.27 0 2.3-.828 2.3-1.843 0-1.014-1.03-1.837-2.3-1.837-1.27 0-2.3.823-2.3 1.837v.01c0 1.016 1.03 1.833 2.3 1.833z"></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path
            fill="#fff"
            d="M0 0H92V92H0z"
            transform="translate(41 39)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}
export function Step3(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="163"
      height="170"
      fill="none"
      viewBox="0 0 163 170"
      {...props}
    >
      <path
        fill="#D5E7F4"
        d="M163 82.96c0 42.462-33.656 87.04-74.406 87.04C47.844 170 0 125.422 0 82.96 0 40.347 47.843 0 88.594 0 129.344 0 163 40.347 163 82.96z"
      ></path>
      <g fill="#5882A0" clipPath="url(#clip0)">
        <path d="M82.011 82.082c-.816 0-1.561-.53-1.836-1.296a1.967 1.967 0 01.598-2.166 1.973 1.973 0 012.269-.148 1.968 1.968 0 01.877 2.083 1.977 1.977 0 01-1.907 1.527z"></path>
        <path d="M121.402 78.176h-5.888v-7.164a1.953 1.953 0 00-1.953-1.953h-3.143l1.457-4.378c.778-2.34 2.163-4.504 4.117-6.433a9.203 9.203 0 002.254-3.628 9.208 9.208 0 00-.635-7.259 9.1 9.1 0 00-5.736-4.508c-4.444-1.176-9.225 1.264-10.884 5.554a9.187 9.187 0 00-.491 4.866c.42 2.442.186 5.103-.676 7.696l-2.692 8.09H48.44a1.953 1.953 0 00-1.953 1.953v7.164h-5.888a6.188 6.188 0 00-6.181 6.181 6.188 6.188 0 006.181 6.181h5.888v14.782c0 7.11 5.785 12.895 12.896 12.895h2.944a7.477 7.477 0 00.93 3.551H59.94c-4.418 0-8.012 3.594-8.012 8.012v1.316h-3.795a1.953 1.953 0 100 3.906h65.731a1.953 1.953 0 100-3.906h-3.795v-1.316c0-4.418-3.594-8.012-8.012-8.012h-3.314a7.477 7.477 0 00.929-3.551h2.945c7.111 0 12.895-5.785 12.895-12.896V90.538h5.888a6.188 6.188 0 006.181-6.181 6.187 6.187 0 00-6.18-6.181zM103.53 62.202c1.065-3.201 1.349-6.518.82-9.591a5.273 5.273 0 01.284-2.795c.951-2.461 3.692-3.861 6.242-3.187a5.23 5.23 0 013.298 2.59 5.217 5.217 0 01.365 4.168 5.205 5.205 0 01-1.292 2.081c-2.395 2.365-4.104 5.05-5.079 7.98l-1.867 5.611h-5.052l2.281-6.856zm-62.932 24.43a2.277 2.277 0 01-2.275-2.275 2.277 2.277 0 012.275-2.275h5.888v4.55h-5.888zm25.634 31.513c0-2.069 2.077-4.62 3.626-6.177 1.547 1.546 3.615 4.083 3.615 6.177a3.625 3.625 0 01-3.62 3.621 3.624 3.624 0 01-3.62-3.621zM81 121.766a3.625 3.625 0 01-3.62-3.621c0-2.069 2.076-4.62 3.625-6.177 1.547 1.546 3.616 4.083 3.616 6.177A3.625 3.625 0 0181 121.766zm25.164 8.012v1.316H55.836v-1.316a4.11 4.11 0 014.105-4.106h42.118a4.11 4.11 0 014.105 4.106zm-17.637-11.633c0-2.069 2.076-4.62 3.626-6.177 1.547 1.546 3.615 4.083 3.615 6.177a3.624 3.624 0 01-3.62 3.621 3.625 3.625 0 01-3.621-3.621zm23.081-12.825c0 4.956-4.033 8.989-8.99 8.989h-3.905c-1.642-3.435-4.86-6.12-5.337-6.505a1.951 1.951 0 00-2.462.004c-.392.319-2.637 2.202-4.335 4.769-1.701-2.575-3.957-4.455-4.35-4.773a1.952 1.952 0 00-2.462.004c-.392.319-2.638 2.202-4.336 4.769-1.7-2.575-3.956-4.455-4.35-4.773a1.954 1.954 0 00-2.461.004c-.476.387-3.683 3.079-5.327 6.501h-3.911c-4.957 0-8.99-4.032-8.99-8.989V82.082h22.756a1.953 1.953 0 000-3.906H50.392v-5.21h61.216v5.21H90.806a1.953 1.953 0 000 3.906h20.802v23.238zm9.794-18.688h-5.888v-4.55h5.888a2.278 2.278 0 012.275 2.275 2.278 2.278 0 01-2.275 2.275z"></path>
        <path d="M55.058 66.66c-4.404 0-7.986-3.582-7.986-7.985 0-4.404 3.582-7.986 7.986-7.986 4.403 0 7.986 3.582 7.986 7.986 0 4.403-3.583 7.986-7.986 7.986zm0-12.065c-2.25 0-4.08 1.83-4.08 4.08s1.83 4.08 4.08 4.08 4.08-1.83 4.08-4.08-1.83-4.08-4.08-4.08zM82.62 62.34c-1.537 0-2.624-.169-2.741-.188a1.953 1.953 0 01-1.616-1.615c-.051-.319-1.218-7.856 2.966-12.04 4.184-4.183 11.72-3.017 12.04-2.965.83.134 1.48.785 1.615 1.615.052.319 1.218 7.856-2.966 12.04-2.65 2.65-6.644 3.153-9.298 3.153zm-.632-3.912c2.125.077 5.384-.22 7.168-2.003 1.884-1.884 2.067-5.237 1.994-7.169-2.127-.075-5.377.223-7.159 2.004-1.783 1.783-2.08 5.04-2.003 7.168zM69.915 56.958c-.4 0-.8-.123-1.142-.369-.262-.189-6.416-4.694-6.416-10.61 0-5.916 6.154-10.421 6.416-10.61a1.953 1.953 0 012.285 0c.262.189 6.416 4.694 6.416 10.61 0 5.916-6.154 10.421-6.416 10.61a1.95 1.95 0 01-1.143.369zM69.91 39.5c-1.557 1.45-3.646 3.96-3.646 6.479 0 2.522 2.094 5.035 3.653 6.485 1.557-1.448 3.651-3.962 3.651-6.485 0-2.664-2.24-5.164-3.658-6.479z"></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path
            fill="#fff"
            d="M0 0H100V100H0z"
            transform="translate(31 35)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}
export function BurgerMenu({className}: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M4 12L20 12"></path>
      <path d="M4 6L20 6"></path>
      <path d="M4 18L20 18"></path>
    </svg>
  );
}
export function Plant({className}: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M11 20A7 7 0 019.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"></path>
      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>
    </svg>
  );
}
export function Vegan({className}: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      className={className}
    >
      <path d="M2 2a26.6 26.6 0 0110 20c.9-6.82 1.5-9.5 4-14M16 8c4 0 6-2 6-6-4 0-6 2-6 6M17.41 3.6a10 10 0 103 3"></path>
    </svg>
  );
}
export function Dessert({className}: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      className={className}
    >
      <circle cx="9" cy="7" r="2"></circle>
      <path d="M7.2 7.9L3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6M16 13H3M16 17H3"></path>
    </svg>
  );
}
